import React from "react";
import PrivateRoute from "./Private/Private.jsx";
import PublicRoute from "./Public/Public.jsx";

import { PAGES } from "./Pages.jsx";

const routes = [
  {
    path: "/unauthorized",
    element: <PublicRoute />,
    children: PAGES.PUBLIC_PAGES,
  },
  {
    path: "/under-maintenance",
    element: <PublicRoute />,
    children: PAGES.MAINTENANCE_PAGE,
  },
  {
    path: "/",
    element: <PrivateRoute />,
    children: PAGES.PRIVATE_PAGES,
  },
];

export default routes;
